:host(.is-selected){background-color:#d0c6f0}img{max-width:100%;height:auto}
/*# sourceMappingURL=read-only-text-cell.component.css.map */
